import React, { createContext, useContext } from 'react';
import { ITenantContext } from '../../types/tenant';
import { useTenantData } from '../../hooks/useTenant';

const TenantContextProvider = createContext<ITenantContext | null>(null);

export const useTenant = () => {
  const context = useContext(TenantContextProvider);
  if (!context) {
    throw new Error('useTenant must be used within a TenantProvider');
  }
  return context;
};

interface TenantProviderProps {
  children: React.ReactNode;
}

export const TenantProvider: React.FC<TenantProviderProps> = ({ children }) => {
  const tenantData = useTenantData();

  return (
    <TenantContextProvider.Provider value={tenantData}>
      {children}
    </TenantContextProvider.Provider>
  );
};